// flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

// components
import ErrorModal from '../../containers/ErrorModal/ErrorModal';
import DateFooter from 'components/atoms/DateFooter';

import './AppointmentError.scss';

class AppointmentError extends React.Component<Props> {
  static block = 'appointment-error';

  constructor(props: Props, context: any) {
    super(props, context);
    (this: any).modal = React.createRef();
  }

  setShowModal = (show: boolean = true) => {
    (this: any).modal.current.setShowModal(show);
  };

  render() {
    const ns = AppointmentError.block;
    const { date, ...otherProps } = this.props;

    return (
      <ErrorModal
        ref={this.modal}
        icon={() => <div className={`${ns}__traffic-light my-4`} />}
        content={() => {
          return (
            <div className={ns}>
              <DateFooter date={date} />

              <FormattedMessage id="c8.error.no.longer.available">
                {text => <div className={`${ns}__title mt-5 mb-4`}>{text}</div>}
              </FormattedMessage>

              <FormattedMessage id="c8.error.choose.diferent.date.time">
                {text => <div className={`${ns}__message mb-5`}>{text}</div>}
              </FormattedMessage>
            </div>
          );
        }}
        {...otherProps}
      />
    );
  }
}

export default AppointmentError;



// WEBPACK FOOTER //
// ./src/components/api/components/AppointmentNotAvailable/AppointmentError.js